import { APP_VERSION } from '../App';

export function AppFooter({ className = 'login-page-footer' }: { className?: string }) {
  return (
    <footer className={className}>
      <p>&copy; {new Date().getFullYear()} Belafonte TACOLCY Center. All rights reserved. &nbsp;v{APP_VERSION}</p>
    </footer>
  );
}
